<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 865.80798 367.72134"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs
      id="defs6"
    >
      <clipPath
        id="clipPath20"
        clipPathUnits="userSpaceOnUse"
      >
        <path
          id="path18"
          d="M 0,275.791 H 649.356 V 0 H 0 Z"
        />
      </clipPath>
    </defs>
    <sodipodi:namedview
      id="namedview4"
      bordercolor="#000000"
      borderopacity="0.25"
      inkscape:deskcolor="#d1d1d1"
      inkscape:pagecheckerboard="0"
      inkscape:pageopacity="0.0"
      inkscape:showpageshadow="2"
      pagecolor="#ffffff"
    />
    <g
      id="g8"
      inkscape:groupmode="layer"
      inkscape:label="Cards TM White Red Print 2024 (1)"
      transform="matrix(1.3333333,0,0,-1.3333333,0,367.72133)"
    >
      <g
        id="g10"
        transform="translate(607.1404,123.163)"
      >
        <path
          id="path12"
          d="m 0,0 h 6.869 v -16.138 h 2.77 V 0 h 6.898 V 2.159 H 0 Z"
          style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
        />
      </g>
      <g
        id="g14"
      >
        <g
          id="g16"
          clip-path="url(#clipPath20)"
        >
          <g
            id="g22"
            transform="translate(642.636,125.3224)"
          >
            <path
              id="path24"
              d="m 0,0 -4.988,-12.739 c -0.51,-1.278 -0.874,-2.262 -1.122,-2.926 -0.205,0.6 -0.54,1.495 -0.992,2.708 L -12.046,0 h -4.156 v -18.298 h 2.669 v 15.576 l 6.037,-15.576 h 2.494 L 1.065,-2.99 V -18.298 H 3.719 L 3.719,0 Z"
              style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
            />
          </g>
          <g
            id="g26"
            transform="translate(514.5651,148.471)"
          >
            <path
              id="path28"
              d="m 0,0 c -0.798,11.105 2.049,23.272 -7.683,25.178 -15.613,1.022 -20.529,10.074 -20.529,24.374 0,14.301 4.179,25.319 18.682,28.269 6.391,1.72 8.121,8.77 8.681,20.083 0.073,10.857 -2.006,14.417 -7.393,17.06 -27.956,10.499 -63.451,5.824 -82.24,-22.268 -0.986,0.561 -0.625,0.344 -1.624,0.953 0.425,4.337 2.393,12.166 -3.529,18.088 -13.818,11.122 -58.202,12.544 -80.513,-6.497 0,0 -0.201,2.543 -2.017,4.478 -4.296,4.58 -15.627,10.892 -40.29,9.023 -30.003,-3.032 -57.816,-23.347 -61.165,-55.878 l -0.024,-0.036 c -7.367,19.897 -15.692,42.419 -16.513,44.796 -2.866,8.303 -11.553,8.801 -30.205,9.819 l -0.067,0.006 c -8.818,9.14 -23.677,9.186 -32.516,0 -18.652,-1.018 -27.401,-1.516 -30.267,-9.819 -1.5,-4.343 -28.037,-75.897 -28.037,-75.897 -6.587,-17.139 14.858,-36.99 32.01,-38.938 v 0.002 h -89.175 c -5.105,0 -10,-0.981 -14.564,-2.921 -4.465,-1.903 -8.423,-4.567 -11.746,-7.897 -3.348,-3.343 -6.011,-7.302 -7.905,-11.743 -1.947,-4.548 -2.935,-9.454 -2.935,-14.582 v -63.401 c 0,-5.118 0.986,-10.021 2.925,-14.559 1.902,-4.462 4.564,-8.42 7.899,-11.75 3.348,-3.354 7.31,-6.016 11.766,-7.912 4.553,-1.94 9.452,-2.923 14.56,-2.923 h 96.126 c 0.01,0 0.019,-0.002 0.028,-0.002 l 22.706,-0.336 c 0.064,-0.001 0.126,-0.001 0.188,-0.001 3.99,0 7.891,1.599 10.731,4.403 2.886,2.849 4.541,6.809 4.541,10.864 v 19.765 h 30.977 v -19.431 c 0,-8.309 6.761,-15.156 15.045,-15.264 l 19.858,-0.29 v -0.002 h 0.131 l 3.012,-0.044 c 0.064,-0.001 0.126,-0.001 0.188,-0.001 0.302,0 0.602,0.027 0.903,0.045 h 12.717 c 0.003,0 0.005,0 0.007,0 l 18.865,-0.281 c 0.082,-0.002 0.164,-0.002 0.247,-0.002 4.502,0 8.9,1.808 12.098,4.983 3.258,3.234 5.107,7.721 5.073,12.315 l -0.14,18.643 8.312,0.04 h 0.005 c 0.249,0 0.482,-0.108 0.642,-0.3 l 24.33,-28.972 c 3.269,-3.896 8.061,-6.13 13.148,-6.13 h 25.121 c 0.306,0 0.603,0.05 0.907,0.066 H 57.979 c 0,0 34.794,-3.477 35.02,33.92 0.093,1.089 0.16,2.185 0.16,3.295 v 20.965 c 0,5.057 -0.975,9.913 -2.895,14.436 -1.897,4.462 -4.603,8.43 -8.053,11.806 -0.153,0.149 -0.307,0.298 -0.464,0.444 l 11.412,4.96 v 9.986 c 0,5.058 -0.975,9.914 -2.895,14.436 -1.902,4.475 -4.612,8.448 -8.053,11.806 -3.341,3.264 -7.251,5.863 -11.628,7.728 -4.517,1.919 -9.324,2.893 -14.291,2.893 0,0 -60.164,-0.004 -61.313,-0.004 2.638,1.472 5.174,3.883 5.02,8.153 z"
              style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none"
            />
          </g>
          <g
            id="g30"
            transform="translate(207.3896,252.2221)"
          >
            <path
              id="path32"
              d="m 0,0 25.089,-78.124 h -50.178 z m -35.565,-4.406 c -2.785,0 -5.043,2.258 -5.043,5.042 0,2.785 2.258,5.042 5.043,5.042 2.784,0 5.042,-2.257 5.042,-5.042 0,-2.784 -2.258,-5.042 -5.042,-5.042 M -46.038,-78.124 H -96.216 L -71.127,0 Z m 76.312,-0.3 c -0.132,0.189 -0.343,0.3 -0.567,0.3 L 0.337,1.388 C 0.317,1.432 0.283,1.473 0.248,1.506 V 1.508 C 0.21,1.542 0.167,1.571 0.113,1.591 v 0.002 c 0,0 -0.039,0.009 -0.054,0.013 L 0.055,1.608 H 0.051 0.048 V 1.61 H 0.044 0.04 c -0.07,0.012 -7.147,1.067 -24.568,1.401 -1.669,2.609 -5.219,6.759 -10.944,6.803 h -0.187 C -41.384,9.77 -44.934,5.62 -46.603,3.011 -64.024,2.677 -71.101,1.622 -71.171,1.61 h -0.004 -0.004 V 1.608 h -0.003 -0.004 L -71.19,1.606 C -71.205,1.602 -71.244,1.593 -71.244,1.593 V 1.591 c -0.054,-0.02 -0.097,-0.049 -0.135,-0.083 V 1.506 c -0.035,-0.033 -0.062,-0.074 -0.082,-0.118 l -29.373,-79.512 c -0.224,0 -0.435,-0.111 -0.567,-0.3 -0.132,-0.189 -0.17,-0.432 -0.102,-0.655 0.067,-0.219 1.697,-5.439 6.259,-10.724 4.212,-4.881 11.816,-10.699 24.117,-10.699 12.3,0 19.904,5.818 24.117,10.699 4.561,5.285 6.191,10.505 6.258,10.724 0.069,0.223 0.031,0.466 -0.102,0.655 -0.132,0.189 -0.342,0.3 -0.566,0.3 L -70.595,0.829 c 0.025,-0.002 0.043,-0.004 0.043,-0.004 4.441,-0.224 33.917,-2.303 33.917,-17.214 -0.004,-0.572 0.26,-53.983 -3.525,-80.748 -6.783,-7.947 -19.535,-9.677 -19.712,-9.698 -0.201,-0.025 -0.348,-0.201 -0.333,-0.402 0.012,-0.201 0.178,-0.358 0.379,-0.358 h 48.521 c 0.201,0 0.367,0.157 0.379,0.358 0.015,0.201 -0.132,0.377 -0.333,0.402 -0.177,0.021 -12.929,1.751 -19.713,9.698 -3.784,26.765 -3.52,80.176 -3.524,80.748 0,14.911 29.476,16.99 33.917,17.214 0,0 0.02,0.002 0.047,0.004 l -29.175,-78.953 c -0.224,0 -0.435,-0.111 -0.567,-0.3 -0.132,-0.189 -0.17,-0.432 -0.101,-0.655 0.067,-0.219 1.697,-5.439 6.258,-10.724 4.213,-4.881 11.816,-10.699 24.117,-10.699 12.301,0 19.904,5.818 24.117,10.699 4.561,5.285 6.191,10.505 6.258,10.724 0.068,0.223 0.031,0.466 -0.101,0.655"
              style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
            />
          </g>
          <g
            id="g34"
            transform="translate(326.0884,236.8457)"
          >
            <path
              id="path36"
              d="m 0,0 c -6.89,4.072 -14.562,6.109 -22.543,6.109 -25.213,0 -41.966,-18.166 -41.966,-42.749 0,-25.678 18.477,-42.744 41.183,-42.744 7.826,0 18.311,2.037 23.793,5.322 l 0.941,-15.185 c -8.298,-3.445 -18.474,-3.916 -24.893,-3.916 -34.606,0 -57.624,22.233 -57.624,56.992 0,33.668 24.426,56.057 57.783,56.057 8.447,0 16.745,-1.252 24.576,-4.699 z"
              style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
            />
          </g>
          <g
            id="g38"
            transform="translate(412.6898,235.4361)"
          >
            <path
              id="path40"
              d="m 0,0 c -7.673,5.009 -15.97,7.516 -30.058,7.516 -25.213,0 -41.966,-18.321 -41.966,-42.747 0,-25.678 18.478,-42.743 41.183,-42.743 10.797,0 13.621,1.095 17.533,1.878 v 33.192 h -23.014 v 12.838 H 2.349 v -56.831 c -5.948,-2.036 -16.286,-4.856 -33.348,-4.856 -34.606,0 -57.624,22.232 -57.624,56.991 0,33.666 24.426,56.055 57.782,56.055 15.97,0 23.014,-2.349 32.098,-5.481 z"
              style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
            />
          </g>
          <g
            id="g42"
            transform="translate(503.2365,236.8438)"
          >
            <path
              id="path44"
              d="m 0,0 c -6.893,4.072 -14.562,6.108 -22.551,6.108 -25.205,0 -41.954,-18.164 -41.954,-42.747 0,-25.677 18.469,-42.743 41.171,-42.743 7.831,0 18.327,2.037 23.805,5.321 l 0.937,-15.185 c -8.301,-3.444 -18.477,-3.915 -24.892,-3.915 -34.606,0 -57.624,22.233 -57.624,56.991 0,33.667 24.43,56.056 57.774,56.056 8.46,0 16.761,-1.252 24.588,-4.699 z"
              style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
            />
          </g>
          <g
            id="g46"
            transform="translate(51.8283,102.928)"
          >
            <path
              id="path48"
              d="m 0,0 h 73.896 l -0.345,23.324 h -85.228 c -3.094,0 -5.983,-0.574 -8.675,-1.718 -2.691,-1.147 -5.034,-2.714 -7.027,-4.711 -1.996,-1.992 -3.563,-4.336 -4.71,-7.026 -1.152,-2.692 -1.722,-5.585 -1.722,-8.673 v -63.401 c 0,-3.092 0.57,-5.976 1.722,-8.672 1.147,-2.692 2.714,-5.035 4.71,-7.028 1.993,-1.995 4.336,-3.563 7.027,-4.707 2.692,-1.147 5.581,-1.722 8.675,-1.722 h 85.573 l -0.345,23.328 H 0 c -5.873,0 -10.633,4.757 -10.633,10.63 v 39.743 C -10.633,-4.76 -5.873,0 0,0"
              style="fill:#cf1f2f;fill-opacity:1;fill-rule:nonzero;stroke:none"
            />
          </g>
          <g
            id="g50"
            transform="translate(453.6376,52.5411)"
          >
            <path
              id="path52"
              d="m 0,0 c 0,-5.797 -4.7,-10.497 -10.498,-10.497 h -49.738 v 60.235 h 49.738 C -4.7,49.738 0,45.038 0,39.239 Z M 16.678,66.419 C 14.711,68.387 12.4,69.938 9.744,71.071 7.083,72.2 4.23,72.767 1.182,72.767 H -83.115 V -33.526 H 1.182 c 3.048,0 5.901,0.563 8.562,1.699 2.656,1.129 4.967,2.678 6.934,4.649 1.974,1.966 3.55,4.281 4.728,6.937 1.18,2.658 1.771,5.511 1.771,8.563 v 62.597 c 0,3.049 -0.591,5.905 -1.771,8.561 -1.178,2.658 -2.754,4.968 -4.728,6.939"
              style="fill:#cf1f2f;fill-opacity:1;fill-rule:nonzero;stroke:none"
            />
          </g>
          <g
            id="g54"
            transform="translate(518.0034,102.2783)"
          >
            <path
              id="path56"
              d="m 0,0 h 42.817 c 4.806,0 8.708,-3.9 8.708,-8.713 l 23.18,9.719 V 1.18 c 0,3.05 -0.569,5.906 -1.698,8.564 -1.13,2.656 -2.709,4.97 -4.725,6.937 -2.018,1.971 -4.357,3.519 -7.013,4.652 -2.658,1.129 -5.463,1.695 -8.415,1.695 H -9.744 c -3.055,0 -5.903,-0.566 -8.561,-1.695 -2.657,-1.133 -4.971,-2.681 -6.937,-4.652 C -27.218,14.714 -28.765,12.4 -29.894,9.744 -31.028,7.086 -31.59,4.23 -31.59,1.18 v -20.964 c 0,-3.049 0.562,-5.905 1.696,-8.562 1.129,-2.657 2.676,-4.972 4.652,-6.938 1.966,-1.971 4.28,-3.52 6.937,-4.652 2.658,-1.13 5.506,-1.693 8.561,-1.693 h 52.561 c 4.806,0 8.708,-3.902 8.708,-8.713 v -1.181 c 0,-4.813 -3.902,-8.71 -8.708,-8.71 H 0 c -4.809,0 -8.71,3.897 -8.71,8.71 l -22.88,-9.718 v -0.175 c 0,-3.052 0.562,-5.902 1.696,-8.562 1.129,-2.658 2.676,-4.972 4.652,-6.938 1.966,-1.971 4.28,-3.52 6.937,-4.649 2.658,-1.133 5.506,-1.699 8.561,-1.699 h 62.598 c 2.952,0 5.757,0.566 8.415,1.699 2.656,1.129 4.995,2.678 7.013,4.649 2.016,1.966 3.595,4.28 4.725,6.938 1.129,2.66 1.698,5.51 1.698,8.562 v 20.964 c 0,3.05 -0.569,5.906 -1.698,8.564 -1.13,2.656 -2.709,4.966 -4.725,6.937 -2.018,1.971 -4.357,3.519 -7.013,4.652 -2.658,1.132 -5.463,1.698 -8.415,1.698 H 0 c -4.809,0 -8.71,3.901 -8.71,8.71 v 1.178 C -8.71,-3.9 -4.809,0 0,0"
              style="fill:#cf1f2f;fill-opacity:1;fill-rule:nonzero;stroke:none"
            />
          </g>
          <g
            id="g58"
            transform="translate(220.4646,76.6124)"
          >
            <path
              id="path60"
              d="m 0,0 h -60.757 c -0.139,0 -0.251,0.112 -0.251,0.251 v 14.795 c 0,6.223 5.044,11.268 11.267,11.268 h 38.857 C -4.873,26.314 0,21.441 0,15.43 Z m 16.892,43.213 c -1.993,1.992 -4.336,3.564 -7.023,4.711 -2.696,1.144 -5.585,1.715 -8.672,1.715 h -63.256 -0.016 c -12.216,-0.003 -22.116,-9.91 -22.109,-22.126 v -85.284 c 0,-0.138 0.11,-0.249 0.248,-0.251 l 22.673,-0.335 c 0.14,-0.002 0.255,0.111 0.255,0.251 v 0.335 34.194 c 0,0.139 0.112,0.252 0.251,0.252 h 60.506 c 0.139,0 0.251,-0.113 0.251,-0.252 v -34.194 c 0,-0.138 0.11,-0.249 0.247,-0.251 l 22.972,-0.335 c 0.14,-0.002 0.255,0.111 0.255,0.251 v 85.619 c 0,3.084 -0.598,5.981 -1.798,8.672 -1.189,2.692 -2.784,5.032 -4.784,7.028"
              style="fill:#cf1f2f;fill-opacity:1;fill-rule:nonzero;stroke:none"
            />
          </g>
          <g
            id="g62"
            transform="translate(326.5533,77.3581)"
          >
            <path
              id="path64"
              d="m 0,0 h -46.073 c -1.188,0 -2.152,0.963 -2.152,2.152 v 21.266 c 0,1.188 0.964,2.152 2.152,2.152 H 0 c 7.061,0 12.785,-5.724 12.785,-12.785 C 12.785,5.724 7.061,0 0,0 m 36.259,-50.838 c -3.788,4.484 -7.678,9.071 -11.666,13.755 -3.986,4.687 -7.872,9.27 -11.659,13.759 h 1.046 c 3.084,0 5.981,0.569 8.672,1.718 2.692,1.147 5.032,2.742 7.028,4.784 0.998,1.022 1.896,2.125 2.693,3.309 0.798,1.184 1.495,2.449 2.091,3.794 1.2,2.692 1.795,5.533 1.795,8.523 v 27.812 c 0,2.992 -0.595,5.831 -1.795,8.523 -0.596,1.345 -1.293,2.61 -2.091,3.794 -0.797,1.184 -1.695,2.288 -2.693,3.31 -1.996,2.041 -4.336,3.636 -7.028,4.785 -2.691,1.144 -5.588,1.717 -8.672,1.717 h -83.222 v 0 c -0.893,0 -1.658,-0.543 -1.984,-1.318 -0.109,-0.258 -0.168,-0.541 -0.168,-0.839 l 0.255,-103.502 c 10e-4,-0.587 0.238,-1.119 0.621,-1.507 0.191,-0.194 0.419,-0.351 0.673,-0.462 0.253,-0.11 0.532,-0.173 0.826,-0.177 l 18.86,-0.281 c 0.302,-0.005 0.59,0.053 0.852,0.161 0.524,0.216 0.944,0.634 1.164,1.156 0.11,0.262 0.17,0.549 0.168,0.851 l -0.25,33.699 23.364,0.114 c 4.711,0.023 9.188,-2.051 12.218,-5.659 l 24.33,-28.975 c 0.103,-0.122 0.217,-0.231 0.341,-0.326 0.372,-0.284 0.83,-0.443 1.307,-0.443 v 0 h 25.122 c 1.849,0 2.837,2.18 1.618,3.571 z"
              style="fill:#cf1f2f;fill-opacity:1;fill-rule:nonzero;stroke:none"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>

</template>

<script>
export default {
  name: 'Cgc',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
